import React, { useState } from "react";

export function InputField({ bulkGenerate, selectedEventId }) {
  const [csvFile, setCsvFile] = useState(null);
  const [templateFile, setTemplateFile] = useState(null);
  const [mappingFile, setMappingFile] = useState(null);
  const [manualPositioning, setManualPositioning] = useState(true);

  const handleBulkGeneration = async (e) => {
    e.preventDefault();

    if (!selectedEventId) {
      alert("Please select an event first");
      return;
    }

    if (!csvFile || !templateFile) {
      alert("Please select both CSV file and template image");
      return;
    }

    if (manualPositioning && !mappingFile) {
      alert("Please upload a mapping.json file for manual positioning");
      return;
    }

    await bulkGenerate(csvFile, templateFile, mappingFile, manualPositioning);

    // Reset form
    setCsvFile(null);
    setTemplateFile(null);
    setMappingFile(null);
    e.target.reset();
  };

  return (
    <div className="bulk-generation-form">
      <h3>Bulk Certificate Generation</h3>

      {selectedEventId ? (
        <div className="event-info">
          <p>
            📅 <strong>Event ID:</strong> {selectedEventId}
          </p>
        </div>
      ) : (
        <div className="event-warning">
          ⚠️ Please select an event from the dropdown above
        </div>
      )}

      <form onSubmit={handleBulkGeneration}>
        <div className="form-group">
          <label>CSV Data File:</label>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => setCsvFile(e.target.files[0])}
            required
          />
          <small>
            Format: name, email, eventName, eventDate, certificateNumber
          </small>
        </div>

        <div className="form-group">
          <label>Certificate Template:</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setTemplateFile(e.target.files[0])}
            required
          />
          <small>PNG, JPG, or other image formats</small>
        </div>

        <div className="form-group">
          <label>
            <input
              type="checkbox"
              checked={manualPositioning}
              onChange={(e) => setManualPositioning(e.target.checked)}
            />
            Use Manual Positioning (requires mapping.json)
          </label>
        </div>

        {manualPositioning && (
          <div className="form-group">
            <label>Mapping File (mapping.json):</label>
            <input
              type="file"
              accept=".json"
              onChange={(e) => setMappingFile(e.target.files[0])}
              required={manualPositioning}
            />
            <small>JSON file with field coordinates and styling</small>
          </div>
        )}

        <button
          type="submit"
          disabled={!selectedEventId}
          className={!selectedEventId ? "disabled" : ""}
        >
          Generate Certificates
        </button>
      </form>
    </div>
  );
}
